function FooterLinks({ el }) {
    return (
        <>
            <a href='#!'>{el}</a>
        </>
    )
}

export default FooterLinks